import { useDispatch, useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/currency';
import { config } from '../../../../utils/config';
import Icon from '../../elements/icon';

import { useAddUpsellMutation } from '../../../../store/newCart';
import { startLoading } from '../../../../store/application';
import './index.scss';
import i18n from '../../../../utils/translations/i18n';
import { logSentryTransacation } from '../../../../utils/sentry';
import {ReactComponent as GreenTick} from "../../../../assets/icons/green-tick.svg";
import cartActions from '../../../../store/cartActions';
import { LineItemType } from '../../../../enums/lineItemType';
import { RootState } from '../../../../store';
import tierUtils from "../../../../utils/tier";
import { TierPricesObject } from '../../../../models/tiers';
import { mobileAndTabletDetection } from '../../../../utils/browser';
import { cartInteractionEvent } from '../../../../utils/analytics/google';
import { CartInteraction } from '../../../../enums/cartInteraction';

const Upsell = ({cart, lineItemId}: {cart: any, lineItemId: string}) => {
    const { t } = i18n;
    const dispatch = useDispatch();
    const [addUpsell] = useAddUpsellMutation();
    const isTypeUpsell = () => cart?.lineItems[lineItemId].find(lineItem => lineItem?.type === LineItemType.UPSELL);
    const isAdded = Boolean(isTypeUpsell());

    const mainItem = cart?.lineItems[lineItemId]?.[0]?.data ?? {};

    const { applicationState: { tierPricesData } } = useSelector((state: RootState) => state);
    const tierDataForMainItem: TierPricesObject = tierPricesData[mainItem?.productKey] || [];
   
    if(Object.keys(mainItem).length === 0) return <></>;

    const actualTier = tierUtils.getTierForQuantity(tierDataForMainItem?.tierObject, mainItem.quantity) ?? {};
    let originalTier: any = {};

    if (tierDataForMainItem?.isStrikeOutPricing) {
        originalTier = tierUtils.getTierForQuantity(tierDataForMainItem?.oldPrices, mainItem.quantity) ?? {};
    }
    
    const addUpsellHandler = async () => {
        const transaction = logSentryTransacation("addUpsell");
        dispatch(startLoading());
        cartInteractionEvent(
            CartInteraction.UPSELL_ADD,
            mainItem?.webCode || mainItem?.productFamilyName
        );
        await addUpsell({
            mainLineItemId: mainItem.id,
            cartId: cart.id
        });
        transaction?.finish();
    }

    function removeUpsellHandler() {
        cartInteractionEvent(
            CartInteraction.UPSELL_REMOVE,
            mainItem?.webCode || mainItem?.productFamilyName
        );
        dispatch(cartActions.removeLineItem(isTypeUpsell()?.data?.id, LineItemType.UPSELL, cart, mainItem.id));
    }

    const strikeOutUpsellPrice  = tierDataForMainItem?.isStrikeOutPricing && actualTier?.upsellUnitPrice !== originalTier?.upsellUnitPrice ? <span className="line-through">{currencyFormatter(originalTier?.upsellQuantity * originalTier?.upsellUnitPrice, cart.fractionDigits)}</span> : '';
    const upsellPrice  = <span className="shopping-bag__promo__title_upsell">+{currencyFormatter(actualTier?.upsellQuantity * actualTier?.upsellUnitPrice, cart.fractionDigits)}!</span>;

    return (
        <div className={`shopping-bag__promo ${isAdded ? 'upsellAdded' : 'upsellNotAdded'}`}>
            {!isAdded && <Icon color='$color-discount' className="upsellAdd btn" onClick={addUpsellHandler} >+ {t('shopping_cart_details.add_now')}</Icon>}
            <div className='child-container'>
                <div>
                    <div className="upsell-content">
                        {config('regionCode') === 'HU' &&
                            <span>{isAdded && !mobileAndTabletDetection() && t('header.logo_imprint_added')} {actualTier?.upsellQuantity} db {t('shopping_cart_details.add_upsell_content')} {strikeOutUpsellPrice} {upsellPrice}</span>
                        }
                        {config('regionCode') !== 'HU' &&
                            <span>{isAdded && !mobileAndTabletDetection() && t('header.logo_imprint_added')} {actualTier?.upsellQuantity} {t('shopping_cart_details.add_upsell_content')} {strikeOutUpsellPrice} {upsellPrice} </span>
                        }
                    </div>
                </div>
                {isAdded && <div className='upsell-remove' tabIndex={0} role="button" onClick={removeUpsellHandler}>{t('shopping_cart_details.removeButton')}</div>}
            </div>
            {isAdded && <div className='child-container green-tick-container'><GreenTick /></div>}
        </div>
    )

}

export default Upsell;
